import { Outlet } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Dock } from './Dock'
import { WhatsNewGate } from '@/features/whatsnew/WhatsNewSheet'
import { PushInviteGate } from '@/features/notifications/PushInvite'
import { getHomeSummary } from '@/services/api/sightings'
import { useSession } from '@/stores/session'

/** The signed-in frame: a scrolling page, with the dock floating over it. */
export function AppShell() {
  const user = useSession((s) => s.user)

  // The badge count rides along with data Home needs anyway.
  const { data } = useQuery({
    queryKey: ['home-summary', user?.id],
    queryFn: getHomeSummary,
    enabled: Boolean(user),
    staleTime: 30_000,
  })

  return (
    <>
      <Outlet />
      <Dock pendingRequests={data?.pending_requests ?? 0} />
      <WhatsNewGate />
      <PushInviteGate />
    </>
  )
}
